export default __webpack_public_path__ + "static/media/TheAmpersandLobby.d72332f3.jpg";